import {
  InnerBlocks,
  useInnerBlocksProps,
  useBlockProps,
  InspectorControls,
  BlockControls,
} from '@wordpress/block-editor';

import {
  PanelBody,
  PanelRow,
  ToggleControl,
  RangeControl,
  ToolbarGroup,
} from '@wordpress/components';

import MediaPicker from '@components/ui/MediaPicker';
import ResponsiveImage from '@components/ui/ResponsiveImage';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';

import BiteLinkPanel from '@components/DesignPanel/LinkPanel';
import { useState, useEffect } from '@wordpress/element';
import LinkPicker from '@components/HelperControls/LinkPicker';

export default function Edit({ attributes, setAttributes }) {
  const {
    media,
    imageProps,
    mediaStyle,
    mediaClass,
    flexStyle,
    flexClass,
    linkUrl,
    linkTitle,
    linkTarget,
    bitePreset,
    biteStyle,
    biteClass,
  } = attributes;

  // update attribute
  const linkCallback = (link) => {
    setAttributes({ ...link });
  };

  const blockProps = useBlockProps({
    className: `bf_relative`,
  });

  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    {
      className: `bf_layout ${flexClass}`,
    },
    {
      template: [['core/paragraph']],
    }
  );

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title={'Link'} initialOpen={false}>
          <BiteLinkPanel
            parentCallback={linkCallback}
            linkUrl={linkUrl}
            linkTitle={linkTitle}
            linkTarget={linkTarget}
            showLinkTile={false}
          />
        </PanelBody>
      </InspectorControls>
      <BlockControls group="other">
        <ToolbarGroup>
          <LinkPicker
            parentCallback={linkCallback}
            linkUrl={linkUrl}
            linkTitle={linkTitle}
            linkTarget={linkTarget}
            showLinkTile={false}
          />
        </ToolbarGroup>
      </BlockControls>
      {media.id ? (
        <>
          {media.type === 'video' ? (
            <ResponsiveVideo media={media} mediaClass={`${mediaClass}`} />
          ) : (
            <ResponsiveImage media={media} mediaClass={`${mediaClass}`} />
          )}
        </>
      ) : null}
      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
}
